// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"428abe3e","777":"12faade4"}[chunkId] + ".chunk.js";
};